import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './customSwitch.module.scss';

export const CustomSwitch = (props) => {
    return (
        <div>
            <Form.Check
                type="switch"
                id={props.id}
                className={`
                        ${props.classType === "defaultSwitch" && styles.defaultSwitch}
                        ${props.classType === "defaultSwitchColoredSuccess" && styles.defaultSwitchColoredSuccess}
                        ${props.classType === "defaultSwitchColoredDanger" && styles.defaultSwitchColoredDanger}
                        ${props.classType === "animateSwitch" && styles.animateSwitch}
                        ${props.classType === "animateSwitchActive" && styles.animateSwitchActive}
                        ${props.classType === "colorTopSwitch" && styles.animateSwitch}
                        ${props.classType === "custom-switch" && styles.customswitch}
                    `}
                    
                onChange={props.handleChange}
                checked={props.isChecked}
                disabled={props.disabled}
                name={props.name}
            />
        </div>
    )
}

CustomSwitch.defaultProps = {
    id: 'custom-switch',
    classType: 'defaultSwitch'
};

